module.exports = __webpack_public_path__ + "static/img/2.a2016a2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Empresarial-Fraude-Empleados/2.png
// module id = pxXb
// module chunks = 0